import React from 'react'

import { __, sprintf } from 'StylistParent/i18n'
import { forEach } from 'lodash'
// import Tooltip from '../../../tooltip'

/* Import CSS */
import './index.scss'

class Units extends React.Component {

	changeUnit = ( event ) => {	
		// Send value up to the parent component (Control).
		this.props.changeUnit( event.target.value )
	}

	render() {
		const cssUnitsGeneral = [
			{
				label: 'px',
				value: 'px',
			},
			{
				label: '%',
				value: '%',
			},
			{
				label: 'vh',
				value: 'vh',
			},
			{
				label: 'em',
				value: 'em',
			},
		];

		const cssLineHeightUnits = [
			{
				label: 'px',
				value: 'px',
			},
			{
				label: 'em',
				value: 'em',
			},
			{
				label: 'relative',
				value: '',
			},
		];

		let cssUnits = Object.keys( this.props.cssUnits )
		let unitOptions = []

		forEach( cssUnits, ( unit ) => {
			let unitLabel = unit
			let unitValue = unitLabel

			if ( '' === unitLabel && 'line-height' === this.props.cssProperty ) {
				unitLabel = '⌘'
			}
			unitOptions.push( {
				label: unitLabel,
				value: unitValue,
			} )
		} )

		return (
			<select
				className="css-unit"
				onChange={this.changeUnit}
				value={this.props.currentUnit}>
				{ unitOptions.map( ( option, index ) => (
					<option
						value={ option.value }
						key={ index }>{ option.label }</option>
				) ) }
			</select>
		)

	}
}

export default Units;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/units/index.jsx